const cmpVendorsFallback = {
  instagram: { name: 'instagram', id: '6054c53ca228639c6f285121', type: 'custom', consent: 'false' },
  facebook: { name: 'facebook', id: '5e7e1298b8e05c54a85c52d2', type: 'custom', consent: 'false' },
  twitter: { name: 'twitter', id: '5e71760b69966540e4554f01', type: 'custom', consent: 'false' },
  megaphone: { name: 'megaphone', id: '5e7e1298b8e05c54a85c52d2', type: 'custom', consent: 'false' },
  outbrain: { name: 'outbrain', id: '164', type: 'iab', consent: 'false' },
  comscore: { name: 'comscore', id: '77', type: 'iab', consent: 'false' },
  youtube: { name: 'youtube', id: '5e7ac3fae30e7d1bc1ebf5e8', type: 'custom', consent: false },
  typeform: { name: 'typeform', id: '5f6b54c6f519d043b5879bcd', type: 'custom', consent: false },
};

export const getCmpVendors = () => window?.SkyFoundationSettings?.cmpVendors || cmpVendorsFallback;

export const getCmpVendorId = (vendorName) => getCmpVendors()[vendorName]?.id;
